import swal from "sweetalert";
import NotificationService from "../services/notififcation_services";
import Page from "./page";

const PushNotifications: React.FC = () => {

    const handleSend = async (type: string) => {
        const response = await swal({
            title: "Cuidado",
            text: "¿Estás segur@ de enviar este mensaje?",
            buttons: ['Si, Enviar', 'No, Cerrar']
        });

        if (response === null) {
            const title = document.querySelector("#title-push") as HTMLInputElement;
            const content = document.querySelector("#content-push") as HTMLInputElement;
            swal("Cargando ...");
            await new NotificationService().sendPush(type, title.value, content.value);
            swal.close();

            title.value = "";
            content.value = "";
        }
    }

    return (
        <Page>
            <div style={{ padding: 15 }}>
                <h1 className="title">Enviar Notificaciones</h1>
                <div className="field">
                    <label className="label">
                        Titulo de la Notificacion
                    </label>
                    <input type="text" className="input" placeholder="Titulo" id="title-push"/>
                </div>
                <div className="field">
                    <label className="label">
                        Cuerpo de la Notificacion
                    </label>
                    <input type="text" className="input" placeholder="Contenido" id="content-push"/>
                </div>


                <div className="buttons">
                    <button className="button is-success" onClick={()=> handleSend("ALL")}>
                        ENVIAR A TODOS
                    </button>

                    <button className="button is-success" onClick={()=> handleSend("DRIVERS")}>
                        ENVIAR A CONDUCTORES (DRIVERS)
                    </button>

                    <button className="button is-success" onClick={()=> handleSend("DELIVERY")}>
                        ENVIAR A REPARTIDORES (DELIVERY)
                    </button>
                </div>

            </div>
        </Page>
    );
}

export default PushNotifications;